export default {
  login: {
    username: "Email",
    password: "Password",
    signIn: "Sign in",
    title: "Cube Back-Office",
    subtitle: "Manage game and casino configurations.",
    loginFailed: "Bad credentials"
  },
  common: {
    masterData: "Master Data",
    casinos: "Casinos",
    integrations: "Integrations",
    integration: "Integration",
    casino: "Casino",
    games: "Games",
    game: "Game",
    bridges: "Bridges",
    manage: "Manage",
    versions: "Versions",
    version: "Version",
    user: "User",
    logout: "Logout",
    name: "Name",
    bridge: "Bridge",
    adapter: "Adapter",
    properties: "Properties",
    key: "Key",
    value: "Value",
    username: "Username",
    password: "Password",
    deleteConfirmation: "Please type the following into the input field to continue: ",
    pleaseChoose: "Please choose",
    status: "Status",
    save: "Save",
    reporting: "Reporting",
    currency: "Currency",
    all: "All",
    date: "Date",
    sum: "Sum",
    dateRange: "Date range",
    noResults: "No results.",
    deactivate: "Deactivate",
    activate: "Activate",
    active: "Active",
    valid: "Valid",
    description: "Description",
    add: "Add",
    delete: "Delete",
    support: "Support",
    search: "Search",
    yes: 'Yes',
    no: 'No',
    start: 'Start',
    end: 'End',
    playerId: 'Player id',
    gameId: 'Game id',
    totalWagered: 'Wagered',
    totalWon: 'Won',
    rtp: 'RTP',
    theoreticalRtp: 'Theoretical RTP',
    happenedAt: 'Happened on',
    createdAt: 'Created on',
    checkedOn: 'Checked on',
    component: 'Component',
    hash: 'Hash',
    allowedHashes: 'Allowed hashes',
    result: 'Result',
    cpv: 'CPV',
    firstPlay: 'First game',
    gameCycles: 'Games played',
    gameCyclesGambled: 'Games gambled',
    gameCyclesGambledAndWon: 'Games gambled and won',
    wageredInOpen: 'Wager in open games',
    wageredInRefunded: 'Wager in refunded games',
    wageredInGamble: 'Wager in gambled games',
    wonInGamble: 'Won in gambled games',
    dataType: "Data Type"
  },
  masterData: {
    jurisdictions: "Jurisdictions",
    addJurisdiction: "Add Jurisdiction",
    editJurisdiction: "Edit Jurisdiction",
    deleteJurisdiction: "Delete Jurisdiction",
    deleteJurisdictionDescription: "You can delete only that Jurisdiction which is not in use",
    createJurisdictionSuccess: "Jurisdiction saved successfully",
    editJurisdictionSuccess: "Saved successfully"
  },
  integrations: {
    name: "Integration Name",
    saveSuccess: "Integration successfully saved",
    id: "Integration Id",
    idPlaceholder: "Integration Id",
    add: "Add integration",
    edit: "Edit integration",
    newIntegrationPlaceholder: "New integration",
    addDescription: "An integration requires a bridge. It enables the definition of playable game versions.",
    delete: "Delete integration",
    deactivateGameTitle: "Deactivate game",
    deactivateGameDescription: ["Deactivating a game disables players to start new game rounds.", "Any open game round can still be played until completion."],
    activateGameTitle: "Activate game",
    activateGameDescription: ["Activating a game enables players to start new game rounds."],
    gameDeactivated: "Game deactivated.",
    gameActivated: "Game activated.",
    gameAdded: "Game added to integration",
    gameRoundValidityPeriod: "Game round validity period",
    gameRoundValidityPeriodHelp: "The amount of days it takes for an open game round to be automatically refunded.",
    gameActive: "Active",
    gameInactive: "Inactive",
    addProperty: "Add property",
    pushPageTitle: "Push Integration configuration",
    settings: "Settings",
    pushSuccessful: "Integration configuration successfully pushed.",
    pushFailed: "Push failed",
    defaultCasinoId: "Default Casino ID",
    defaultCasinoIdPlaceHolder: "-",
    bridgeInfo: "Bridge Info"
  },
  casinos: {
    add: "Add casino",
    edit: "Edit casino",
    newCasinoPlaceholder: "My new casino",
    idPlaceholder: "cf_mynewcasino",
    id: "Casino ID",
    name: "Casino Name",
    addDescription: "A casino requires a bridge and an adapter configuration. It enables the definition of playable game versions.",
    adapterConfiguration: "Adapter configuration",
    apiUrl: "API URL",
    secret: "Secret",
    key: "Key",
    jurisdictionKey: "Jurisdiction key",
    addProperty: "Add property",
    showDevelopStartPage: "Develop start page",
    saveSuccess: "Casino successfully saved",
    deleteSuccess: "Casino successfully deleted",
    delete: "Delete casino",
    gameAdded: "Game added to casino",
    gameRemoved: "Game removed from casino",
    password: "Password",
    username: "Username",
    pushPageTitle: "Push casino configuration",
    pushSuccessful: "Casino configuration successfully pushed.",
    pushFailed: "Push failed",
    sendEventMessages: "Send event messages",
    options: "Options",
    gameDeactivated: "Game deactivated.",
    deactivateGameTitle: "Deactivate game",
    deactivateGameDescription: ["Deactivating a game disables players to start new game rounds.", "Any open game round can still be played until completion."],
    gameActivated: "Game activated.",
    activateGameTitle: "Activate game",
    activateGameDescription: ["Activating a game enables players to start new game rounds."],
    gameActive: "Active",
    gameInactive: "Inactive",
    createIntegrationOptionSuccess: "Integration option successfully saved.",
    integrationOption: "Integration option",
    integrationOptions: "Integration options",
    createCasinoIntegrationOption: "Create integration option",
    editCasinoIntegrationOption: "Edit integration option",
    editIntegrationOptionSuccess: "Integration option successfully saved.",
    selectIntegrationOption: "Select integration option",
    deleteIntegrationOptionSuccess: "Integration option successfully deleted.",
    deleteCasinoIntegrationOption: "Delete integration option",
    deleteCasinoIntegrationOptionDescription: "You can only delete an integration option if it is not used by a casino.",
    gameRoundValidityPeriod: "Game round validity period",
    maxRTP: "Max RTP",
    maxRTPHelp: "The RTP for game win.",
    gameRoundValidityPeriodHelp: "The amount of days it takes for an open game round to be automatically refunded.",
    settings: "Settings"
  },
  games: {
    add: "New game",
    edit: "Edit game",
    addDescription1: "A game consists of a name and a unique identifier.",
    addDescription2: "It bundles multiple game version which in turn can be used for a casino configuration.",
    newGamePlaceholder: "My new game",
    gameId: "Game id",
    gameIdPlaceholder: "cf_mynewgame",
    saveSuccess: "Game successfully saved",
    deleteSuccess: "Game successfully deleted",
    delete: "Delete game",
    theoreticalReturnToPlayer: 'Theoretical RTP',
    theoreticalReturnToPlayerPlaceholder: '0.00'
  },
  bridges: {
    add: "Add bridge",
    edit: "Edit bridge",
    addDescription: "A bridge is an endpoint which accepts casino and game configurations. It serves the configured games to the requesting client and handles casino specific requirements.",
    newBridgePlaceholder: "My new bridge",
    routerUrlPlaceholder: "https://my-new-bridge.com",
    routerUrl: "Router-URL",
    saveSuccess: "Bridge successfully saved",
    deleteSuccess: "Bridge successfully deleted",
    delete: "Delete bridge",
    addProperty: "Add property"
  },
  versions: {
    frontendUrl: "Frontend-URL",
    backendUrl: "Backend-URL",
    historyUrl: "History-URL",
    add: "Add version",
    edit: "Edit version",
    addDescription: "A game version describes locations where a client can access its frontend and backend resources.",
    versionPlaceholder: "v1.51",
    frontendUrlPlaceholder: "https://your-frontend-cdn.com",
    backendUrlPlaceholder: "https://your-backend.com",
    historyUrlPlaceholder: "https://your-history-cdn.com",
    saveSuccess: "Version successfully saved",
    deleteSuccess: "Version successfully deleted",
    delete: "Delete version",
    missingProperties: "Missing properties",
    missingPropertiesExist: "There are missing properties!",
    jurisdictions: "Jurisdictions",
    selectJurisdiction: "Select jurisdiction",
    betSizes: "Bet Sizes",
    betSizesPlaceHolder: "Enter a bet sizes"
  },
  reporting: {
    revenues: "Revenues",
    winnings: "Winnings",
    stake: "Stake",
    ggr: "Revenue",
    rtp: "RTP",
    playerHistory: "Player history",
    playerId: "Player id",
    playerIdPlaceholder: "Enter a player id",
    timestamp: "Timestamp",
    game: "Game",
    gameRoundId: "Game round id",
    gameRoundCredit: "Game round credit",
    credit: "Credit",
    debit: "Debit",
    reports: "Reports",
    downloadGamePerformanceReport: "Download game performance report",
    downloadGamePerformanceReportDescription: "Creates a CSV-File that contains the total wagered and won amounts of the game in the selected time period.",
    download: "Download",
    downloadAuditLog: "Download audit log",
    downloadAuditLogDescription: "A csv file with all configuration changes.",
    downloadCPVReport: "Download cpv report",
    downloadCPVReportDescription: "A csv file containing the results of the daily authentication checks.",
    downloadFailedBookingsReport: "Download failed bookings report",
    downloadFailedBookingsReportDescription: "A csv file containing all failed bookings.",
    downloadSignificantEventsReport: "Download significant events",
    downloadSignificantEventsReportDescription: "All manual changes to the system are logged as important events.",
    downloadGamePlayHistory: "Download game play history",
    downloadGamePlayHistoryDescription: "The game play history contains all game rounds of a player.",
    gamePerformanceReports: "Game performance reports",
    significantEvents: 'Significant Events',
    createSignificantEvent: 'Create significant event',
    createSignificantEventSuccess: 'Signficant event has been created.',
    cpvChecks: 'Checks',
    checkComponents: 'Check components',
    checkComponentsDescription: 'Checks if all components run in an allowed version. This operations takes a few seconds.',
    triggerCPVCheckSuccessful: 'Components have been checked.',
    downloadReport: 'Download Report',
    casinoPerformanceReport: "Casino Performance Report",
    gamesPlayed: "Games Played",
    bet: "Bet"
  },
  cpv: {
    allowedHashes: 'Allowed hashes',
    allowedHash: 'Allowed hash',
    addAllowedHash: 'Allow hash',
    addAllowedHashSuccessful: 'Hash successfully allowed.',
    removeAllowedHashSuccessful: 'Hash successfully removed.',
    component: 'Component',
    hash: 'Hash',
  },
  support: {
    openGameRounds: "Open game rounds",
    playerId: "Player id",
    gameName: "Game",
    creationDate: "Start",
    openGameRound: "Open game round",
    player: 'Player',
    debit: 'Debit',
    credit: 'Credit',
    totalWin: 'Total win',
    refundable: 'Refundable',
    notRefundable: 'Not refundable',
    refundOpenGameRound: 'Refund open game round',
    refundOpenGameRoundDescription: ['Refunding an open game round returns the debit back to the player.', 'If the player has already made credits refunding is not possible anymore.'],
    enterGameRoundId: 'Enter the game round id.',
    refund: 'Refund',
    refundSuccess: "Open game round successfully refunded.",
  },
  report: {
    error: {
      noData: 'No data found.'
    }
  },
  backOffice: {
    reporting: {
      noConnection: 'Reporting-Service does not respond.'
    }
  },
  errors: {
    jurisdiction: {
        error: {
          nameAlreadyTaken: "The name is already taken"
        }
        },
    game: {
      error: {
        gameIdAlreadyInUse: "The given game id is already used by another game."
      }
    },
    integration:{
      error: {
        casinosBoundToIntegration: "To delete integration first unbound casinos"
      }
    },
    casino: {
      error: {
        casinoIdAlreadyTaken: "The given casino id is already taken by another casino.",
        configIsNotApplicableToSelectedAdapter: "The given adapter config is not applicable for the selected adapter.",
        noBridgeConfigured: "The given casino is missing a bridge configuration.",
        gameIsAlreadyAssigned: "The game is already assigned to the casino.",
        integrationOptionInUse: "Integration option is used by a casino.",
        jurisdictionInUse: "Jurisdiction is used by a casino.",
        casinoIdIsDefault: "Casino is used as default in integration."
      },
    },
    casinoIntegrationOption: {
      error: {
        nameAlreadyTaken: 'The name is already taken.'
      }
    },
    gameVersion :{
      error: {
        versionAlreadyTaken: "The given version number is already taken."
      }
    }
  }
}
